export default "__VITE_PUBLIC_ASSET__2d1603bb__"